/** @format */

import { NgForm } from '@angular/forms';

export interface AddressFormData {
  address: {
    address: string;
    address2: string;
    city: string;
    country: string;
    first_name: string;
    last_name: string;
    state: string;
    zipcode: string;
  };
  saveThisAddress: boolean;
  saveAsPrimaryAddress: boolean;
  form: NgForm;
}
